import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Spin, Typography } from "antd";
import { useIntl } from "react-intl";
const { Text } = Typography;
const PdfViewerModal = (props) => {
  const { contentType, visible, onHide, activeFileUrl } = props;
  const [key, setKey] = useState(0);
  const isPdf = contentType.includes("pdf");
  const isImage = contentType.includes("image");
  const isNotSpported = !isImage && !isPdf;
  const intl = useIntl();
  useEffect(() => {
    // Force re-render when activeFileUrl changes
    setKey((prevKey) => prevKey + 1);
  }, [activeFileUrl]);

  return (
    <Modal
      closable={true}
      footer={null}
      onCancel={onHide}
      title={null}
      centered
      width={"80vw"}
      open={visible}
      styles={{
        body: {
          height: "80vh",
          padding: "20px",
        },
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isPdf && activeFileUrl ? (
          <object
            key={key}
            data={activeFileUrl}
            name="name"
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <p></p>
          </object>
        ) : isImage && activeFileUrl ? (
          <img
            key={key}
            src={activeFileUrl}
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
              padding: "40px",
            }}
            alt="asset"
          />
        ) : isNotSpported ? (
          <Text>
            {intl.formatMessage({
              id: "app.assets.not_supported",
            })}
          </Text>
        ) : (
          <Spin />
        )}
      </div>
    </Modal>
  );
};

export default PdfViewerModal;
